/* eslint-disable no-continue */
/* eslint-disable no-multi-assign */
/* eslint-disable no-bitwise */
export const guessImageBackgroundColor = (imgEl) => {
  return new Promise((resolve) => {
    const blockSize = 5;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext && canvas.getContext('2d');
    let i = -4;
    if (!context) {
      resolve('#000000');
    }

    const height = (canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height);
    const width = (canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width);

    context.drawImage(imgEl, 0, 0);
    let data;
    try {
      data = context.getImageData(0, 0, width, height);
    } catch (e) {
      /* security error, img on diff domain */ console.log('Error trying to guess image color');
      resolve('#000000');
    }
    const { length } = data.data;

    const widthPixels = width / 30;
    const heightPixels = height / 30;
    let color = { red: 0, green: 0, blue: 0 };
    let count = 0;
    // eslint-disable-next-line no-cond-assign
    while ((i += blockSize * 4) < length) {
      const pixel = i / 4;
      const heightLocation = pixel / width;
      const heightCenter = heightLocation > heightPixels && heightLocation < height - heightPixels;
      const widthLocation = pixel / height;
      const widthCenter = widthLocation > widthPixels && widthLocation < width - widthPixels;

      if (heightCenter && widthCenter) {
        i += blockSize * 96;
        continue;
      }
      ++count;
      color = {
        red: color.red + data.data[i],
        green: color.green + data.data[i + 1],
        blue: color.blue + data.data[i + 2],
      };
    }
    const finalColor = {
      red: ~~(color.red / count),
      green: ~~(color.green / count),
      blue: ~~(color.blue / count),
    };
    resolve(rgb2hex(finalColor));
  });
};

export const rgb2hex = ({ red, green, blue }) => {
  const rgb = blue | (green << 8) | (red << 16);
  return `#${(0x1000000 + rgb).toString(16).slice(1)}`;
};

export const hex2Rgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        red: parseInt(result[1], 16),
        green: parseInt(result[2], 16),
        blue: parseInt(result[3], 16),
      }
    : null;
};

export const getBase64Image = (img) => {
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0);
  const dataURL = canvas.toDataURL('image/png');
  return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
};

export const fillImageWithColor = (src, baseColor) => {
  const baseColorRgb = hex2Rgb(baseColor);
  return new Promise((resolve) => {
    const image = new Image();
    image.src = src;
    image.onload = (e) => {
      const path = e.composedPath();
      const img = path[0];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const height = (canvas.height = img.naturalHeight || img.offsetHeight || img.height);
      const width = (canvas.width = img.naturalWidth || img.offsetWidth || img.width);
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, width, height);
      const { data: imagePixels } = imageData;

      for (let i = 0; i < imagePixels.length; i += 4) {
        if (imagePixels[i + 3] === 0) {
          imagePixels[i] = baseColorRgb.red;
          imagePixels[i + 1] = baseColorRgb.green;
          imagePixels[i + 2] = baseColorRgb.blue;
          imagePixels[i + 3] = 255;
        }
      }
      ctx.putImageData(imageData, 0, 0);
      const img64 = canvas.toDataURL();
      resolve(img64);
    };
  });
};
